<template>
  <VCheckbox required v-model="form.userAgreement" @input="setCheckedAllCheckBoxes">
    Отправляя форму, я принимаю условия
    <VLink @click.stop="openContract('userAgreement')">пользовательского соглашения</VLink>
  </VCheckbox>

  <VCheckbox required v-model="permissionForProcessingAgreement">
    Отправляя форму, я даю
    <VLink @click.stop="openContract('permissionForProcessing')">согласие на обработку ПД</VLink>
    и подтверждаю, что ознакомился с
    <VLink @click.stop="openContract('userConfidential')">политикой в отношении обработки ПД</VLink>
  </VCheckbox>
</template>


<script lang="ts">
import LoginForm from "@/pages/common/LoginPage/LoginForm";
import ContractsPublicService from "@/domains/Contracts/ContractsPublicService.js";

export default defineComponent({
  name: 'FormAgreementCheckbox',

  props: {
    /** Модель формы логина. Компонент пишет флаги акцепта прямо в неё —
     * вьюхам не нужно слушать события и пробрасывать значения */
    form: {
      type: LoginForm,
      required: true,
    },
  },

  computed: {
    /** Галочка согласия на обработку ПД акцептует сразу два документа:
     * само согласие и политику в отношении обработки ПД */
    permissionForProcessingAgreement: {
      get(): boolean {
        return this.form.permissionForProcessing && this.form.userConfidential;
      },
      set(value: boolean) {
        this.form.permissionForProcessing = value;
        this.form.userConfidential        = value;
      },
    },
  },

  methods: {
    /** Открывает актуальную версию публичного договора */
    async openContract(contractType: string) {
      const contract = await ContractsPublicService.getActualContract(contractType);

      const route = this.$router.resolve(`${ContractsPublicService.baseUrl}/${contractType}/${contract.version}`);
      window.open(route.href, '_blank');
    },

    setCheckedAllCheckBoxes(newValue: boolean) {
      if (newValue === true) {
        this.permissionForProcessingAgreement = true;
      }
    }
  },
});
</script>
